// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from '@firebase/firestore';

import { getStorage } from '@firebase/storage'

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBXnCCP6Byw1FeEznHzxjk9a_vv9UgNpAU",
  authDomain: "stephanie-faria.firebaseapp.com",
  projectId: "stephanie-faria",
  storageBucket: "stephanie-faria.firebasestorage.app",
  messagingSenderId: "1052322519572",
  appId: "1:1052322519572:web:fa024f53e7c63514f4e501"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore()
export const storage = getStorage(app)